import SpreedlyPaymentService from '../../spreedly-payment-service';
import getCsrfToken from '~Utils/get-csrf-token';

export default ({ envKey = undefined, token = undefined }) => ({
  init() {
    this.service = new SpreedlyPaymentService(envKey);
    this.isChallengeModalShown = false;
    this.challengeText = '';
  },

  async start() {
    this.service.onScriptError = (msg, source, lineno, colno, err) => {
      console.log([msg, source, lineno, colno, err]);
      this.$dispatch(
        'flash-message',
        'An error has occurred. Please try again or contact support.'
      );
    };

    await this.service.install();

    this._prepEvents();

    const lifecycle = this.service.build3DSLifecycle({
      hiddenIframeLocation: this.$refs['device-fingerprint'].id,
      challengeIframeLocation: this.$refs['challenge-container'].id,
      transactionToken: token,
      challengeIframeClasses: 'SpreedlyChallengeIframe',
    });

    lifecycle.start();
  },

  _prepEvents() {
    this.service.on('3ds:status', async (_Spreedly, event) => {
      switch (event.action) {
        case 'succeeded':
        case 'error':
          this.$refs.form.submit();
          break;

        case 'challenge':
          // this.isChallengeModalShown = true;
          break;

        case 'device-fingerprint':
          this.challengeText = `device-fingerprint...(10s)`;
          console.log(
            'spreedly doing device fingerprinting, should transition to "trigger-completion" in 10s...'
          );
          break;

        case 'trigger-completion':
          await this._triggerCompletion(event);
          break;

        case 'fallback':
          // Occurs during the fallback workflow. Ignore.
          break;

        default:
          console.debug(`Unknown Spreedly 3DS Event: ${event.action} => ${JSON.stringify(event)}`);

          break;
      }
    });
  },

  async _triggerCompletion(event) {
    // This is an example of the authenticated call that you'd make
    // to your service.
    // 1. make a request to your backend to do an authenticated call to Spreedly to complete the request
    //    The completion call is `https://core.spreedly.com/v1/transactions/[transaction-token]/complete.json (or .xml)`
    // 2a. if the transaction is marked as "succeeded" finish your checkout and redirect to success page
    // 2b. if the transaction is marked "pending" you'll need to call finalize `event.finalize(transaction)` with the transaction data from the authenticated completion call.

    const csrfToken = getCsrfToken();

    const response = await fetch(`/billing/fingerprint_complete_3ds/${event.token}.json`, {
      method: 'POST',
      headers: {
        'Content-type': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
    });

    const data = await response.json();

    switch (data.state) {
      case 'succeeded':
        this.challengeText = `fingerprint success: ${event.token}`;
        this.$refs.form.submit();
        break;

      case 'pending':
        event.finalize(data);
        break;

      case 'gateway_processing_failed':
        this.challengeText = `gateway_processing_failed`;
        break;

      default:
        console.debug(
          `Unknown Spreedly Completion State: ${data.state} => ${JSON.stringify(data)}`
        );

        break;
    }
  },
});
